import { Injectable } from '@angular/core'
import { Subject } from 'rxjs';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class NavService {

    // Observable navItem source
    private _navItemSource = new BehaviorSubject<number>(0);
    // Observable navItem stream
    navItem$ = this._navItemSource.asObservable();
    // service command

    private _Login = new BehaviorSubject<boolean>(true);
    Login$ = this._Login.asObservable();

    private _onNotification = new BehaviorSubject<any>(null);
    onNotification$ = this._onNotification.asObservable();

    private _walletBalance = new BehaviorSubject<any>(null);
    walletBalance$ = this._walletBalance.asObservable();

    private startDate = new BehaviorSubject<string | null>(null);
    private endDate = new BehaviorSubject<string | null>(null);
    startDate$ = this.startDate.asObservable();
    endDate$ = this.endDate.asObservable();

    private _isDisabledActionList = new BehaviorSubject<boolean>(false);
    isDisabledActionList$ = this._isDisabledActionList.asObservable();

    
    private tripNoSource = new BehaviorSubject<string>('');

    // Gatisaar Change for navigation for same page in trip by aditya 02-10-2025
    tripNo$ = this.tripNoSource.asObservable();

    
    // Gatisaar Change for navigation for same page
    sendTripNo(tripNo: string) {
        this.tripNoSource.next(tripNo);
    }



    changeNav(number) {
        this._navItemSource.next(number);
    }

    LoginAfter(login) {
        this._Login.next(login);
    }

    OnNotification(msg) {
        this._onNotification.next(msg);
    }

    updateWallet(balance) {
        this._walletBalance.next(balance);
    }

    setStartDate(date: string) {
        localStorage.setItem('StartDate', date); // Save to localStorage
        this.startDate.next(date);
    }

    setEndDate(date: string) {
        localStorage.setItem('EndDate', date); // Save to localStorage
        this.endDate.next(date);
    }

    setDisabledActionListState(isDisabled: boolean) {
        this._isDisabledActionList.next(isDisabled);
    }

}